<template>
    <input type="hidden" name="userTimezone" id="userTimezone" :value=userTimezone>
</template>

<script>
    import moment_timezone from 'moment-timezone'

    export default {

        data() {
            return {
                userTimezone: ''
            }
        },

        mounted() {
            this.userTimezone = moment_timezone.tz.guess()
        },

    }
</script>
